// External Imports
import React from 'react';
import PropTypes from 'prop-types';
import omit from 'lodash/fp/omit';
import { DropdownMenu, DropdownMenuItem, Text, Inline } from '@lessonnine/design-system.lib';

// Internal Imports
import { I18n } from '../I18n/I18n.jsx';
import { LANGUAGES } from '../../config/types/prop.js';

// Component Definition
function EditionPicker({ editions, currentEdition }) {
  const filteredEditions = omit([currentEdition], editions);
  const menuItems = Object.keys(filteredEditions).map((languageCode) => {
    const { link, name } = editions[languageCode];
    return <DropdownMenuItem href={link}>{name}</DropdownMenuItem>;
  });

  const labelItem = (
    <Text fontWeight={500} fontSize="medium">
      {editions[currentEdition]?.name}
    </Text>
  );

  if (editions[currentEdition]) {
    return (
      <Inline gap={15} alignItems="center">
        <Text fontWeight={600} fontSize={{ medium: 'medium', small: 'small' }} letterSpacing="0.06">
          <I18n field="babbel-magazine-edition" defaultText="BABBEL MAGAZINE EDITION" />
        </Text>
        <DropdownMenu label={labelItem}>{menuItems}</DropdownMenu>
      </Inline>
    );
  }

  // eslint-disable-next-line unicorn/no-null -- expected return for empty component with React
  return null;
}

EditionPicker.propTypes = {
  currentEdition: LANGUAGES.isRequired,
  editions: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types -- dynamically built
};

// Module Exports
export { EditionPicker };
